import { render, staticRenderFns } from "./Dashbaord.vue?vue&type=template&id=1d198763"
import script from "./Dashbaord.vue?vue&type=script&lang=js"
export * from "./Dashbaord.vue?vue&type=script&lang=js"
import style0 from "./Dashbaord.vue?vue&type=style&index=0&id=1d198763&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports